import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CustomHttpResponse } from '../models/data/CustomHttpResponse';
import { Notification } from '../models/entities/Notification';
import { ApiHttpService } from './api-http.service';

@Injectable({
  providedIn: 'root',
})
export class UserNotificationService {
  private ApiHttpService = inject(ApiHttpService<Notification>);

  markRead(notification: Notification) {
    return this.ApiHttpService.patch(`${notification['@id']}/read`, notification);
  }

  markAllAsRead() {
    return this.ApiHttpService.patch(`/notifications/read`, {});
  }

  markCurrentAsRead(notifications: { notifications: string[] }) {
    return this.ApiHttpService.post(`/notifications/read`, notifications);
  }

  getTotalAmountToRead(): Observable<number> {
    return this.ApiHttpService.get(`/notifications/amount_to_read`).pipe(
      map((response: CustomHttpResponse<AmountToReadResponse>) =>
        response.body ? (response.body as AmountToReadResponse).amountToRead : 0,
      ),
    );
  }
}

interface AmountToReadResponse {
  amountToRead: number;
}
